import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SsgPopoverService {
  private _showText: Subject<{ text: string; event: any }>;

  get showText(): Subject<{ text: string; event: any }> {
    return this._showText;
  }

  constructor() {
    this._showText = new Subject<{ text: string; event: any }>();
  }
}
